/* Click-to-load videos. No microphone or camera APIs. */
(() => {
  if (!customElements.get('muteme-discover-video')) {
    customElements.define('muteme-discover-video', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.onPlay = event => {
          const link = event.target.closest('[data-video-play]');
          if (!link || !this.contains(link) || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          let id;
          try {
            const url = new URL(link.href);
            if (url.protocol !== 'https:' && url.protocol !== 'http:') return;
            if (url.hostname === 'youtu.be') id = url.pathname.slice(1);
            else if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'www.youtube-nocookie.com'].includes(url.hostname)) {
              id = url.pathname === '/watch' ? url.searchParams.get('v') : url.pathname.split('/').filter(Boolean).pop();
            }
          } catch (_) { return; }
          if (!/^[a-zA-Z0-9_-]{11}$/.test(id || '')) return;
          event.preventDefault();
          const frame = document.createElement('iframe');
          frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
          frame.title = this.dataset.videoTitle || 'MuteMe video';
          frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          frame.allowFullscreen = true;
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          frame.setAttribute('tabindex', '0');
          this.replaceChildren(frame);
          frame.focus();
        };
        this.addEventListener('click', this.onPlay);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onPlay);
        this.initialized = false;
      }
    });
  }
})();
